import React, { useEffect, useState,useRef } from 'react';
import '../App.css'; // Optional: for custom styling
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from "./AuthProvider";
import { useNavigate } from "react-router-dom";


const Userdd = ({ username }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { logout, permissions } = useAuth(); 
  const dropdownRef = useRef(null);

  // Toggle dropdown
  const toggleDropdown = () => setIsOpen(!isOpen);

  // Handle click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Mostrar permisos en consola para debugging
  useEffect(() => {
    if (permissions) {
      console.log('🔐 Permisos del usuario en Userdd:', permissions);
    }
  }, [permissions]);

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <div className="dropdown-header" onClick={toggleDropdown}>
        {username}
      </div>
      {isOpen && (
        <ul className="dropdown-list">
          <li onClick={() => { logout(); navigate('/login'); }}>
            Sign out
          </li>
        </ul>
      )}
    </div>
  );
};

export default Userdd;
